import React from 'react';
import {Choice, FieldProp} from '../../types';
import {Select} from './Select';
import {DisplayOnly} from './DisplayOnly';

type WorkflowMultiUserProps = FieldProp & {};

export const WorkflowMultiUser: React.FunctionComponent<WorkflowMultiUserProps> = (props): JSX.Element => {
    const {displayOnly, value} = props;

    // override default etl config with custom values
    if (props.field?.flowCustomDisplayComponentConfig?.etlConfig) {
        props.field.etlConfig = {
            ...props.field.etlConfig,
            ...props.field?.flowCustomDisplayComponentConfig?.etlConfig
        }
    }

    return (
        displayOnly ?
            <DisplayOnly>{value?.map((item: Choice, index: number) => (
                <div key={index}>{item?.text}</div>
            ))}</DisplayOnly>
            :
            <Select {...props} isMulti={true} placeholder="Begin typing user email address" />
    );
};